var MenusHelpers = /** @class */ (function () {
    //Class constructor
    function MenusHelpers() {
        return;
    }
    //Store list of menus
    MenusHelpers.prototype.Init = function (menus) {
        if (menus !== null) {
            this.MenuGroups = menus;
        }
        else {
            this.MenuGroups = [];
        }
    };
    return MenusHelpers;
}());
var Menus = new MenusHelpers();
export default Menus;
//# sourceMappingURL=Menus.js.map